import { endOfMonth, startOfMonth } from 'date-fns';

import { loadFilterOptions, loadQualityScores, loadTopRecognitions } from './queries';
import { parseEndDate, parseMonthDate, parseStartDate } from './utils';

export const loadRecognitionScoresData = async ({ request }: { request: Request }) => {
	try {
		const url = new URL(request.url);
		const searchParams = url.searchParams;
		const startDate = parseStartDate(searchParams.get('top_recognition_start_month'));
		const endDate = parseEndDate(searchParams.get('top_recognition_end_month'));
		const monthDate = parseMonthDate(searchParams.get('overview_month'));
		const monthDateStart = startOfMonth(monthDate);
		const monthDateEnd = endOfMonth(monthDate);

		return Promise.all([
			loadFilterOptions({ startDate, endDate }),
			loadTopRecognitions({ startDate, endDate }),
			loadQualityScores({ startDate: monthDateStart, endDate: monthDateEnd }),
		]);
	} catch (e) {
		console.error(e);
	}
};
